import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import ScrollReveal from 'scrollreveal';
import avatarBottom from '../../assets/avatarBottom.webp';
import facebook from '../../assets/facebook.webp';
import avatar from "../../assets/instructorsAvatar.webp";
import line from '../../assets/line.webp';
import linkedIn from '../../assets/linkedin.webp';
import twitter from '../../assets/twitter.webp';
import { PROFILE_IMAGES_PREFIX, STUDIO_BASE_URL } from "../../config/constants";
import { axiosStudioInstance } from "../../service/axiosStudioConfig";
// import LoadingImg from "../Loading-Img/LoadingImg";
import styles from "./trainer.module.css";
import { useTranslation } from "react-i18next";
import LoadingBar from "../LoadingBar/LoadingBar";
import { LazyLoadImage } from "react-lazy-load-image-component";


export default function Trainer() {
  const { i18n } = useTranslation();
  const imageRef = useRef(null);
  const screenWidth = window.innerWidth;

  useEffect(() => {
    const sr = ScrollReveal();
    sr.reveal(imageRef.current, {
      duration: 500,
      distance: screenWidth < 768 ? "0px" : '100px',
      easing: 'ease-in',
      origin: 'left',
      reset: false,
    });
    //eslint-disable-next-line
  }, []);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [instructors, setInstructorsList] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const handleSelectDetail = (instructor) => {
    const selectedImageIndex = instructors.findIndex((item) => item === instructor);
    setSelectedDetail(instructor);
    setSelectedImageIndex(selectedImageIndex);
  };

  useEffect(() => {
    setIsLoading(true);
    axiosStudioInstance
      .get(`/api/contentstore/v1/instructors2?page=2`)
      .then((res) => {
        let temp = res.data.filter((ob) => {
          if (["Thomas"
            , 'Hala Gamal'
            , "Ahmed Moustafa"
            , "Ahmed Moustafa TEST"
            , "Mai Ahmed"
            , "Amira Badr"
            , "Omar Ahmed"
            , "Customer Demo", "Mai Elbringy", "Saif Ryad"].includes(ob.name) || ob.social_links.length < 2) return null;
          else return ob
        })
        setInstructorsList(temp);
        // console.log(res.data, "tem")
        setSelectedDetail(temp[0]);
        setSelectedImageIndex(instructors.findIndex((item) => item === res.data[0]));
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
    // eslint-disable-next-line
  }, []);
  const { t } = useTranslation();

  return (
    <>
      <div className='d-flex flex-column justify-around-center align-items-center mt-5'>
        <h2 className={styles.trainerTitle}>{t("Instructors")}</h2>
        <LazyLoadImage src={line} alt="underline" className={screenWidth < 768 ? "w-50" : ""} ref={imageRef} />
      </div>

      {isLoading ? (

        <LoadingBar />
      ) : (
        <>
          <div className={screenWidth < 768 ? "d-flex flex-column my-2 justify-content-center align-items-center" : "container my-5 d-flex align-items-center"}>
            {(selectedDetail !== null || (selectedDetail === null && instructors.length > 0)) && (
              <>
                <div dir={i18n.language === "en" ? "rtl" : ""} className={` ${styles.details_instructor} d-flex justify-content-end  ${screenWidth < 768 ? "h-50 my-2" : ""}`}>
                  <LazyLoadImage src={avatar} alt="avatar" className={styles.avatarPosition} />
                  <div className="details-modal d-flex">
                    <div className="details-content">
                      <h2 className={screenWidth < 768 ? styles.NameMobile : "text-center w-100"}>{selectedDetail?.name || instructors[0]?.name}</h2>
                      <p className={screenWidth < 768 ? styles.paragraphMobile : ""} >{selectedDetail?.bio || instructors[0]?.bio}</p>
                      <div className="d-flex justify-content-center align-items-center">
                        {selectedDetail?.social_links.map((e, i) =>
                          <a
                            rel="noreferrer"
                            key={i}
                            target="_blank"
                            href={e?.social_link}
                            className="rounded-circle mx-2"
                          >
                            <LazyLoadImage
                              src=
                              {e?.platform === "facebook" ? facebook :
                                e?.platform === "linkedin" ? linkedIn :
                                  twitter}
                              alt={e?.platform}
                              style={{ width: "40px" }}
                            />
                          </a>
                        )
                        }
                      </div>
                      <div className={styles.buttonTest}>
                        <Link to={`/instructor/${selectedDetail?.username}`} >
                          <button className={`btn btn-primary mb-2  ${styles.button_instructors}`}>{t("View_instructor_profile")}</button>
                        </Link>
                      </div>
                    </div>
                    <LazyLoadImage alt="icon"
                      width={screenWidth < 768 ? "100px" : "50%"}
                      height={screenWidth < 768 ? "100px" : "50%"}
                      className={styles.image_url_full}
                      src={selectedDetail?.profile_image?.image_url_full.replace(STUDIO_BASE_URL, PROFILE_IMAGES_PREFIX) || instructors[0]?.profile_image?.image_url_full.replace(STUDIO_BASE_URL, PROFILE_IMAGES_PREFIX)}
                    />
                  </div>
                  <LazyLoadImage src={avatarBottom} alt="avatar" className={styles.avatarPositionBottom} />
                </div>
              </>
            )}
            <div className={`${screenWidth < 768 ? "w-75 h-50" : "w-100 d-flex justify-content-end"}`}>
              <div className={`${styles.main_box} w-100`}>
                <div className={`d-flex justify-content-around ${screenWidth >= 768 && "mb-5"}`}>
                  {instructors.slice(0, 2).map((instructor, index) => (
                    <div
                      key={index}
                      className={screenWidth < 768 ? `${styles.details_box_mobile}` : `${styles.details_box}`}
                      onClick={() => handleSelectDetail(instructor)}
                    >
                      <div
                        className={`${styles.unselected_image} ${selectedImageIndex === instructors.findIndex((item) => item === instructor)
                          ? styles.selected_image
                          : styles.unselected_image
                          }`}
                      ></div>
                      <LazyLoadImage alt="icon"
                        width="100%"
                        height="100%"
                        className={styles.image_url_full}
                        src={instructor?.profile_image?.image_url_full.replace(
                          STUDIO_BASE_URL,
                          PROFILE_IMAGES_PREFIX
                        )}
                      />
                    </div>
                  ))}
                </div>
                <div className={`d-flex justify-content-around ${screenWidth >= 768 ? " mt-3 " : " mt-5"}`}>
                  {instructors.slice(3, 5).map((instructor, index) => (
                    <div
                      key={index}
                      className={screenWidth < 768 ? `${styles.details_box_mobile}` : `${styles.details_box}`}
                      onClick={() => handleSelectDetail(instructor)}
                    >
                      <div
                        className={`${styles.unselected_image} ${selectedImageIndex === instructors.findIndex((item) => item === instructor)
                          ? styles.selected_image
                          : styles.unselected_image
                          }`} ></div>
                      <LazyLoadImage alt="icon"
                        width="100%"
                        height="100%"
                        className={styles.image_url_full}
                        src={instructor?.profile_image?.image_url_full.replace(
                          STUDIO_BASE_URL,
                          PROFILE_IMAGES_PREFIX
                        )}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center mb-5">
            <Link to="/instructors">
              <button aria-label="button to be clicked"
                aria-labelledby="button to be clicked" className={screenWidth < 768 ? `mt-3 btn btn-primary ${styles.btn_see_all}` : `btn btn-primary ${styles.btn_see_all}`}>
                {t("View All")}
              </button>
            </Link>
          </div>
        </>

      )}

    </>
  );
}